'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _es_ES = require('../../date-picker/locale/es_ES');

var _es_ES2 = _interopRequireDefault(_es_ES);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _es_ES2['default'];